import { whiteSpaceManager } from "../../Utils/CommonFunctions";
import { 
    FILTER_SET_PAYLOAD,
    FILTER_SET_VALUES_PAYLOAD,
    FILTER_INPUTFIELD_CHANGEHANDLER,
    FILTER_REMOVE_FIELD,
    FILTER_NAME_CHANGEHANDLER,
    FILTER_LOAD_LIST,
    FILTER_ACTIVE_FILTER,
    FILTER_SAVE_POPUP,
    FILTER_APPLYALL_CHANGEHANDLER,
    FILTER_ACTIVE_FILTER_AND_PAYLOAD,
    SET_FILTER_AUTO_SUGGESTIONS,
    FILTER_SET_VALUES_PAYLOAD_CALENDAR,
    SET_FILTER_AUTO_SUGGESTIONS_ACTIVITES,
    CLEAR_PREVIOUS_FILTER
} from "../actionTypes/GridFilterActionTypes";
import { updateTableRecordsAction } from "./GridListAction";
//SET FILTER DETAILS PAYLOAD
export const setFilterValuesPayload = (filterValues) => {
    return { 
      type: FILTER_SET_VALUES_PAYLOAD, 
      payload:{
        filterValues:filterValues
      }
    };
  };

export const setFilterValuesPayloadForCalendar = (filterValues) => {
    return { 
      type: FILTER_SET_VALUES_PAYLOAD_CALENDAR, 
      payload:{
        filterValuesCalendar:filterValues
      }
    };
  };

export const setFilterPayload = (filterData) => {
    return { 
    type: FILTER_SET_PAYLOAD, 
    payload:{
        filterData:filterData
    }
    
  };
};


export const filterValueOnChangeHandler = (obj) => {
  console.log("gridFilter Action");
    const {value} = obj;
    return { 
      type: FILTER_INPUTFIELD_CHANGEHANDLER, 
      payload:{
       fieldValue:value,
       ...obj
      }
    };
  };

  export const filterNameChangeHandler = (e) => {
    let value = e.target.value;
    let Regex = /^\s+|\s+$/g; 
    value=whiteSpaceManager(value);
     let trimmedValue = value.replace(Regex,' ');
     const filterName = trimmedValue;
     return {
      type: FILTER_NAME_CHANGEHANDLER,
      payload: {
        filterName: filterName,
      },
    };
  }

  export const filterApplyAllChangeHandler = (e)=>{
    const value = e.target.checked;
    return { 
        type: FILTER_APPLYALL_CHANGEHANDLER, 
        payload:{
            apply_for_all:value
        }
      };
  }

  export const removeAddedFilterField = (index)=>{
    return { 
        type: FILTER_REMOVE_FIELD, 
        payload:{
            filterIndex:index
        }
      };
  }
  
  export const loadFilterList =(object,value)=>{
    return { 
        type: FILTER_LOAD_LIST, 
        payload:{
            object:object,
            value:value
        }
      };
  }

  export const setSelectedFilter = (filter)=>{
    return { 
        type: FILTER_ACTIVE_FILTER, 
        payload:{
            activeFilterPayload:filter
        }
      };
  }

  export const showFilterNamePopup =(isShow,type)=>{
      console.log(type,isShow);
    return { 
        type: FILTER_SAVE_POPUP, 
        payload:{
            isShow:isShow,
            type:type
        }
      };
  }

  export const setSelectedFilterAndPayLoad = (filter,payload)=>{
    return { 
        type: FILTER_ACTIVE_FILTER_AND_PAYLOAD, 
        payload:{
            activeFilterPayload1:filter,
            filterData1:payload
        }
      };
  }

  export const setFilterAutoSuggestions = (getGridFilterAutoComplete)=>{
    return { 
        type: SET_FILTER_AUTO_SUGGESTIONS, 
        payload:{
            getGridFilterAutoComplete:getGridFilterAutoComplete
        }
      };
  }

  export const setFilterAutoSuggestionsActivites = (getGridFilterAutoCompleteAct)=>{
    return { 
        type: SET_FILTER_AUTO_SUGGESTIONS_ACTIVITES, 
        payload:{
            getGridFilterAutoCompleteAct:getGridFilterAutoCompleteAct
        }
      };
  }
 export const clearPreviousFilter = () => {
  return async (dispatch) => {
    // side effect first
    await dispatch(updateTableRecordsAction("gridFilter", {}));

    // then update redux state
    dispatch({ type: CLEAR_PREVIOUS_FILTER });
  };
};

  